// extracted by mini-css-extract-plugin
export default {"button":"styles_button__QKGh2","buttonContent":"styles_buttonContent__mc1Ju"};